/** Shared loading and error presentation primitives. */
import { useUiLocale } from '../app/ui-locale';
import { publicCopy } from '../features/renderer/public-copy';

export function Loading({ text }: { text?: string }) {
  const { locale } = useUiLocale();
  const copy = publicCopy(locale);
  return <div className="df-loading" role="status"><span className="df-spinner" />{text ?? copy.loading}</div>;
}

export function ErrorMessage({ error }: { error: unknown }) {
  const { locale } = useUiLocale();
  const copy = publicCopy(locale);
  const message = error instanceof Error ? error.message : String(error ?? copy.unknownError);
  return <div className="alert alert-danger df-error"><strong>{copy.errorLabel}</strong> {message}</div>;
}
